// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'intersection-observer'
import Http from '@/services/http/'

import router from '@/router'
import store from '@/store'
import '@/filter/index'
import { getCookie,deleteCookie } from '@/services/cookieFunction'
import onlyNumber from '@/directive/'

Vue.use(ElementUI)
Vue.use(onlyNumber); //添加此行=>使用该全局指令
Vue.config.productionTip = false
Vue.prototype.$http = Http;

router.beforeEach((to, from, next) => {
    //判断是否为移动设备，是，则跳转到移动端的路径
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        window.location.href = '/mobile.html#/'
        return
    }
    let isLogin = Boolean(store.state.user.user.userId),
        menuIds = store.state.user.menuIdList || [],
        username=getCookie('username');
    if ((to.path === '/login' || to.path==='/forgetPwd') && isLogin===false){
        return next()
    }
    if(isLogin){
        if(to.path === '/login'){
            return next({ path: from.path })
        }
        next();
    }else{
        deleteCookie('SERVERID');
        deleteCookie('ADMINJSESSIONID');
        next('/login');
    }
});


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js